import { FormHeading } from 'twyne-new.ui';

import ButtonCollapse from './ButtonCollapse';

export default function HeaderContainerForm({ children, ...props }) {
  return <>
    <FormHeading
      {...props}
      sidebarCollapseButton={<ButtonCollapse />}
    >
      {children}
    </FormHeading>
  </>
}
